export default {"src":"/_next/static/media/bikeAlert_40.6985aa49.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};